import { Entity } from "./Entity";
import { Container } from "../HTML/Container/Container";
import type { App } from "./App";
import type { HANavigationApp } from "./HANavigationApp";
import { toMap } from "../../../HA";

export class NavigationAppManager extends Entity {

    public update(app: HANavigationApp) {
        if (!app) {
            return;
        }
        this.setApp(app);
        this.getAppContainer().replaceByTag(app.getTag() as any);
    }

    public updateInfo(data: Map<string, any>) {
        const app = this.getApp();
        if (app) {
            app.updateInfo(data);
        }
    }

    public hide() {
        this.getAppContainer().hide();
    }

    public show() {
        this.getAppContainer().show();
    }

    protected getApp(): HANavigationApp {
        return this.get("app");
    }

    protected setApp(app: App) {
        this.addToData("app", app);
    }

    protected getAppContainer(): Container {
        return this.get("navigationContainer");
    }

    protected initialize(data: any) {
        super.initialize(data);
        const data2 = toMap(data);
        data2.delete("navigationContainer");
        const nav = new Container(data2 as Map<string, any>);
        this.addToData("navigationContainer", nav);
    }
}
